import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSignalSelectionTooltipTrigger = styled(Flex).attrs({
    inline: true,
    alignItems: "baseline",
})<{ $flexGrow?: boolean }>`
    min-width: 0;
    max-width: 100%;
    cursor: default;

    ${({ $flexGrow }) =>
        $flexGrow &&
        `
        flex: 1 1 auto;
    `}
`;

/** Inline text flow — keeps `+N` suffix on the same wrapping line as the label copy. */
export const StyledSignalSelectionTooltipInlineTrigger = styled.span`
    cursor: default;
    display: inline;
`;
